import { create } from "zustand";

export let useFilePreviewModal = create((set) => ({
	display: false,
	file: null, // { name, url }

	showFilePreview: (file) => {
		set({ display: true, file });
	},

	closeFilePreview: () => {
		set({ display: false, file: null });
	},
}));
